import { useContext } from 'react'
import { LoadingContext } from '../providers/LoadingProvider'

const useLoader = () => {

    const context = useContext(LoadingContext)
    if (!context) {
        throw new Error('useError must be used within a ErrorProvider');
    }

    return context
}

export default useLoader